import { useMutation } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const {
  CONTROLLERS: {
    CHECK: {
      VERSION, BASE, FRONT_SIDE, REAR_SIDE,
    },
  },
} = USER;

export const useDownloadCheckPhotoMutation = ({ customerId, transactionId, checkSide }: { customerId: string, transactionId: string, checkSide: boolean }) => useMutation(
  async () => {
    const { data } = await httpService.get(
      (`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${transactionId}/?side=${checkSide ? FRONT_SIDE : REAR_SIDE}`),
      { responseType: 'blob' },
    );
    return window.URL.createObjectURL(data);
  },
);
